import React from 'react';
import { IconProps } from '../types';
const MinecraftDiscFragment5: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="4" y="5" width="1" height="1" fill="rgba(13, 18, 23, 255)" />
<rect x="5" y="5" width="1" height="1" fill="rgba(13, 18, 23, 255)" />
<rect x="6" y="5" width="1" height="1" fill="rgba(47, 47, 55, 255)" />
<rect x="7" y="5" width="1" height="1" fill="rgba(81, 81, 81, 255)" />
<rect x="3" y="6" width="1" height="1" fill="rgba(13, 18, 23, 255)" />
<rect x="4" y="6" width="1" height="1" fill="rgba(13, 18, 23, 255)" />
<rect x="5" y="6" width="1" height="1" fill="rgba(47, 47, 55, 255)" />
<rect x="6" y="6" width="1" height="1" fill="rgba(81, 81, 81, 255)" />
<rect x="7" y="6" width="1" height="1" fill="rgba(81, 81, 81, 255)" />
<rect x="8" y="6" width="1" height="1" fill="rgba(100, 100, 100, 255)" />
<rect x="9" y="6" width="1" height="1" fill="rgba(81, 81, 81, 255)" />
<rect x="3" y="7" width="1" height="1" fill="rgba(13, 18, 23, 255)" />
<rect x="4" y="7" width="1" height="1" fill="rgba(47, 47, 55, 255)" />
<rect x="5" y="7" width="1" height="1" fill="rgba(81, 81, 81, 255)" />
<rect x="6" y="7" width="1" height="1" fill="rgba(81, 81, 81, 255)" />
<rect x="7" y="7" width="1" height="1" fill="rgba(100, 100, 100, 255)" />
<rect x="8" y="7" width="1" height="1" fill="rgba(81, 81, 81, 255)" />
<rect x="9" y="7" width="1" height="1" fill="rgba(61, 61, 67, 255)" />
<rect x="10" y="7" width="1" height="1" fill="rgba(61, 61, 67, 255)" />
<rect x="11" y="7" width="1" height="1" fill="rgba(3, 65, 80, 255)" />
<rect x="4" y="8" width="1" height="1" fill="rgba(13, 18, 23, 255)" />
<rect x="5" y="8" width="1" height="1" fill="rgba(61, 61, 67, 255)" />
<rect x="6" y="8" width="1" height="1" fill="rgba(100, 100, 100, 255)" />
<rect x="7" y="8" width="1" height="1" fill="rgba(81, 81, 81, 255)" />
<rect x="8" y="8" width="1" height="1" fill="rgba(61, 61, 67, 255)" />
<rect x="9" y="8" width="1" height="1" fill="rgba(61, 61, 67, 255)" />
<rect x="10" y="8" width="1" height="1" fill="rgba(5, 98, 93, 255)" />
<rect x="11" y="8" width="1" height="1" fill="rgba(13, 18, 23, 255)" />
<rect x="5" y="9" width="1" height="1" fill="rgba(13, 18, 23, 255)" />
<rect x="6" y="9" width="1" height="1" fill="rgba(61, 61, 67, 255)" />
<rect x="7" y="9" width="1" height="1" fill="rgba(61, 61, 67, 255)" />
<rect x="8" y="9" width="1" height="1" fill="rgba(61, 61, 67, 255)" />
<rect x="9" y="9" width="1" height="1" fill="rgba(0, 146, 149, 255)" />
<rect x="10" y="9" width="1" height="1" fill="rgba(13, 18, 23, 255)" />
<rect x="6" y="10" width="1" height="1" fill="rgba(13, 18, 23, 255)" />
<rect x="7" y="10" width="1" height="1" fill="rgba(5, 98, 93, 255)" />
<rect x="8" y="10" width="1" height="1" fill="rgba(0, 146, 149, 255)" />
<rect x="9" y="10" width="1" height="1" fill="rgba(13, 18, 23, 255)" />
<rect x="7" y="11" width="1" height="1" fill="rgba(13, 18, 23, 255)" />
<rect x="8" y="11" width="1" height="1" fill="rgba(13, 18, 23, 255)" />
</svg>);
export default MinecraftDiscFragment5;